import { FileInfo, FileInfoProps } from "minimum-ui/core";

import { useLazyFileQuery } from "API";

export const FileInfoWithFetcherV2: React.FC<
  FileInfoProps & { fileId?: string }
> = ({ fileId, disabled, actions, ...rest }) => {
  const [getUploadedFile, { isLoading: isFetchingFile }] = useLazyFileQuery();

  const handleDownload = async () => {
    if (disabled) {
      return;
    }

    if (actions?.download) {
      actions.download();
    } else if (fileId) {
      const res = await getUploadedFile(fileId);
      if (res.data?.file) {
        window.open(res.data.file);
      }
    } else if (rest.url) {
      window.open(rest.url);
    }
  };

  return (
    <FileInfo
      isLoading={isFetchingFile}
      disabled={disabled}
      actions={{ ...actions, download: () => void handleDownload() }}
      {...rest}
    />
  );
};
